import { Redirect, Switch, Route } from 'react-router-dom';
import React, { Suspense } from 'react';
import { Application, Loading } from '@fides/fides-react-components';
import { LogRouter } from './Log';
import { useGlobalConfigContext } from '../contexts/GlobalConfig';

const ClientsMigration = React.lazy(() => import('../../components/pages/AdministratorTools/ClientsMigration'));
const DataImport = React.lazy(() => import('../../components/pages/AdministratorTools/DataImport'));
const GeneralNotifications = React.lazy(() => import('../../components/pages/AdministratorTools/GeneralNotifications'));
const GeneralNotificationViewPage = React.lazy(
  () => import('../../components/pages/AdministratorTools/GeneralNotifications/GeneralNotificationViewPage')
);
const GeneralNotificationEditor = React.lazy(
  () => import('../../components/pages/AdministratorTools/GeneralNotifications/GeneralNotificationEditor')
);
const FileUpload = React.lazy(() => import('../../components/pages/AdministratorTools/FileUpload'));

export const AdministratorToolsRouter = () => {
  const { accessHelper } = useGlobalConfigContext();

  const isAdminImpersonated =
    accessHelper.isFidesAdministrator(Application.EFTWEB) && accessHelper.isImpersonatedAsClient;
  const isFidesAdmin =
    !accessHelper.isImpersonated &&
    (accessHelper.isFidesAdministrator(Application.EFTWEB) ||
      accessHelper.isFidesReadOnlyAdministrator(Application.EFTWEB));

  const administratorToolsSubPath = isFidesAdmin ? 'general-notifications' : 'clients-migration';

  return (
    <Switch>
      <Route path='/administrator-tools/clients-migration' exact>
        <Suspense fallback={<Loading />}>
          {isAdminImpersonated ? <ClientsMigration /> : <Redirect to='/page-not-found' />}
        </Suspense>
      </Route>
      <Route path='/administrator-tools/data-import' exact>
        <Suspense fallback={<Loading />}>
          <Suspense fallback={<Loading />}>
            {isAdminImpersonated ? <DataImport /> : <Redirect to='/page-not-found' />}
          </Suspense>
        </Suspense>
      </Route>
      <Route path='/administrator-tools/general-notifications' exact>
        <Suspense fallback={<Loading />}>
          {isFidesAdmin ? <GeneralNotifications /> : <Redirect to='/page-not-found' />}
        </Suspense>
      </Route>
      <Route path='/administrator-tools/general-notifications/editor/:uniqueId?' exact>
        <Suspense fallback={<Loading />}>
          {isFidesAdmin ? <GeneralNotificationEditor /> : <Redirect to='/page-not-found' />}
        </Suspense>
      </Route>
      <Route path='/administrator-tools/general-notifications/:uniqueId' exact>
        <Suspense fallback={<Loading />}>
          {isFidesAdmin ? <GeneralNotificationViewPage /> : <Redirect to='/page-not-found' />}
        </Suspense>
      </Route>
      <Route path='/administrator-tools/file-upload' exact>
        <Suspense fallback={<Loading />}>{isFidesAdmin ? <FileUpload /> : <Redirect to='/page-not-found' />}</Suspense>
      </Route>
      <Route path='/log'>
        <LogRouter />
      </Route>
      <Redirect from='/administrator-tools/' to={`/administrator-tools/${administratorToolsSubPath}`} exact />
    </Switch>
  );
};
